// Configuration for different organization types and their actions
export const organizationConfig = {
  // Default behavior - generate Google Meet link
  default: {
    action: "generate",
    label: "Generate Google Meet Link",
    showCondition: (podSession) => !podSession.googleMeetLink,
  },

  // Example: Add new organization types here
  // exampleOrg: {
  //   action: "redirect",
  //   label: "Custom Action",
  //   url: "https://example.com",
  //   showCondition: () => true,
  // },
};

// Helper function to get the appropriate action configuration for an organization
export const getOrganizationAction = (organizationId) => {
  return organizationConfig[organizationId] ?? organizationConfig.default;
};

// Helper function to check if an organization should show any action button
export const shouldShowActionButton = (podSession) => {
  if (!podSession) return false;

  const action = getOrganizationAction(podSession.organizationId);
  return action.showCondition(podSession);
};
